// src/App.jsx
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useRef, useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./Pages/Home";
import About from "./Pages/About";
import InitiativesCarousel from "./Pages/IntiativeCrasual";
import NumbersCounter from "./Pages/NumberCounter";
import PresidentSection from "./Pages/PresidentSection";
import Event from "./Pages/Event";
import Gallery from "./Pages/Gallery";
import Language from "./Pages/Language";
import MarathonGallery from "./Pages/MarathonGallery";

function PageTitleManager() {
  const location = useLocation();

  useEffect(() => {
    switch (location.pathname) {
      case "/event":
        document.title = "Events & Initiatives | Nanbhat Janhith Society";
        break;
      case "/gallery":
        document.title = "Photo Gallery | Nanbhat Janhith Society";
        break;
      default:
        document.title = "Nanbhat Janhith Society | Empowering Lives, Creating Impact";
    }
    // Also ensure smooth scroll to top on page navigation
    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [location]);

  return null;
}

function App() {
  const footerRef = useRef(null); // Create ref for footer

  return (
    <Router>
      <PageTitleManager />
      <div className="flex flex-col min-h-screen">
        <Navbar footerRef={footerRef} /> {/* Pass ref to Navbar */}

        {/* Page content that grows to fill available space */}
        <div className="flex-grow">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Home />
                  <PresidentSection />
                  <About />
                  <InitiativesCarousel />
                  <NumbersCounter />
                  <MarathonGallery/>
                  <Language />
                </>
              }
            />
            <Route path="/event" element={<Event />} />
            <Route path="/gallery" element={<Gallery />} />
          </Routes>
        </div>

        <Footer ref={footerRef} /> {/* Pass ref to Footer */}
      </div>
    </Router>
  );
}

export default App;
